export default "__VITE_ASSET__DwOyjT2G__"